import AuthedLayout from "layouts/authed-layout/AuthedLayout";
import DashboardLayout from "layouts/dashboard-layout/DashboardLayout";
import { useAuthDataState } from "lib/states/authState";

import { Navigate, useRoutes } from "react-router-dom";
import {
  BrandsPage,
  BundleUpsertPage,
  BundlesPage,
  CategoriesPage,
  CustomInvoicingPage,
  DashboardPage,
  DealersPage,
  // GraphsPage,
  LoginPage,
  NotFoundPage,
  OrdersPage,
  ProductsPage,
  PromoPage,
  // ReportsPage,
  UsersPage,
  UploadPage,
  InvoicingPage,
  CreateInvoicePage,
  InvoiceDetailsPage,
  ReviewsPage,
  PaymentSuccessPage,
} from "./lazyRoutes";

export default function Router() {
  const [user] = useAuthDataState();
  const routes = useRoutes([
    {
      element: user.isLoggedIn ? <DashboardLayout /> : <AuthedLayout />,
      children: user.isLoggedIn
        ? [
            { index: true, element: <DashboardPage /> },
            { path: "users", element: <UsersPage /> },
            { path: "dealers", element: <DealersPage /> },
            { path: "brands", element: <BrandsPage /> },
            { path: "categories", element: <CategoriesPage /> },
            { path: "products", element: <ProductsPage /> },
            { path: "bundles", element: <BundlesPage /> },
            { path: "bundles/new", element: <BundleUpsertPage /> },
            { path: "bundles/:id", element: <BundleUpsertPage /> },
            { path: "orders", element: <OrdersPage /> },
            { path: "reviews", element: <ReviewsPage /> },
            { path: "promo-codes", element: <PromoPage /> },
            { path: "upload", element: <UploadPage /> },
            { path: "custom-invoicing", element: <CustomInvoicingPage /> },
            { path: "invoicing", element: <InvoicingPage /> },
            { path: "invoicing/create-invoice", element: <CreateInvoicePage /> },
            { path: "invoicing/:invoiceId", element: <InvoiceDetailsPage /> },
            // Payment success routes - handle common Stripe redirect URLs
            { path: "payment/success", element: <PaymentSuccessPage /> },
            { path: "checkout/success", element: <PaymentSuccessPage /> },
            { path: "stripe/success", element: <PaymentSuccessPage /> },
            { path: "payment/confirm", element: <PaymentSuccessPage /> },
            { path: "invoice/payment/success", element: <PaymentSuccessPage /> },
            { path: "invoice/payment/cancel", element: <PaymentSuccessPage /> },
            // { path: "reports", element: <ReportsPage /> },
            // { path: "graphs", element: <GraphsPage /> },
            {
              path: "*",
              element: <Navigate to="/404" replace />,
            },
            {
              path: "/404",
              element: <NotFoundPage />,
            },
          ]
        : [
            { index: true, element: <LoginPage /> },
            {
              path: "*",
              element: <Navigate to="/" replace />,
            },
          ],
    },
  ]);

  return routes;
}